import React, { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const brDay = value => new Intl.DateTimeFormat("en-CA", { timeZone: "America/Sao_Paulo", year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date(value));
export const returnStatus = (contact, now = Date.now()) => {
  const at = Date.parse(contact?.return_at || "");
  if (!Number.isFinite(at)) return "";
  return at < now ? "overdue" : brDay(at) === brDay(now) ? "today" : "future";
};
export function WaitingTime({ contact }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const timer = setInterval(() => setNow(Date.now()), 30000); return () => clearInterval(timer); }, []);
  if (contact?.last_direction !== "in") return null;
  const since = Date.parse(contact.pending_since || contact.last_message_at || "");
  if (!Number.isFinite(since)) return null;
  const mins = Math.max(0, Math.floor((now - since) / 60000));
  const duration = mins < 1 ? "menos de 1 min" : mins < 60 ? `${mins} min` : mins < 1440 ? `${Math.floor(mins / 60)} h ${mins % 60} min` : `${Math.floor(mins / 1440)} dias`;
  return <span className="text-amber-300 text-xs">Sem resposta há {duration}</span>;
}
const localInput = value => {
  if (!value) return "";
  const parts = new Intl.DateTimeFormat("sv-SE", { timeZone: "America/Sao_Paulo", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" }).format(new Date(value));
  return parts.replace(" ", "T");
};
export default function ContactFollowup({ contact, userId, onSaved }) {
  const [at, setAt] = useState(localInput(contact.return_at));
  const [reason, setReason] = useState(contact.loss_reason || "");
  const [busy, setBusy] = useState(false);
  const lock = useRef(false);
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 30000); return () => clearInterval(t); }, []);
  const save = async (clear = false) => {
    if (lock.current) return;
    lock.current = true; setBusy(true);
    try {
      const endpoint = userId ? `/supervisor/users/${userId}/contacts/followup` : "/contacts/followup";
      const { data } = await api.put(endpoint, { phone: contact.phone, return_at: clear || !at ? null : new Date(at + "-03:00").toISOString(), loss_reason: reason || null });
      if (clear) setAt("");
      onSaved?.(data);
      toast.success(clear ? "Retorno concluído" : "Acompanhamento salvo");
    } catch (e) { toast.error(e.response?.data?.detail || "Não foi possível salvar"); }
    finally { lock.current = false; setBusy(false); }
  };
  const status = returnStatus(contact, now);
  return <details className="border-b border-slate-800 px-4 py-2 flex-none text-xs">
    <summary className="cursor-pointer text-pink-300">Retorno e motivo de perda {status && <span className={status === "overdue" ? "text-rose-300" : "text-amber-200"}> · {status === "overdue" ? "Retorno atrasado" : status === "today" ? "Retorno hoje" : "Retorno agendado"}</span>}</summary>
    <form className="mt-2 flex flex-wrap items-end gap-2" onSubmit={e => { e.preventDefault(); save(); }}>
      <label>Retorno (horário de Brasília)<input type="datetime-local" value={at} onChange={e => setAt(e.target.value)} disabled={busy} className="block rounded border border-slate-600 bg-slate-900 p-2" /></label>
      <label>Motivo da venda perdida<select value={reason} onChange={e => setReason(e.target.value)} disabled={busy} className="block rounded border border-slate-600 bg-slate-900 p-2"><option value="">Não informado</option>{["Sem interesse", "Taxa", "Sem margem", "Fechou em outro lugar", "Outro"].map(x => <option key={x}>{x}</option>)}</select></label>
      <button disabled={busy} className="rounded bg-pink-600 px-3 py-2">{busy ? "Salvando…" : "Salvar acompanhamento"}</button>
      {contact.return_at && <button type="button" disabled={busy} onClick={() => save(true)} className="rounded border border-slate-600 px-3 py-2">Concluir retorno</button>}
    </form>
    <p className="mt-1 text-slate-400">O retorno aparece no sistema. Não envia mensagem automaticamente.</p>
  </details>;
}
